export const KPI_ADMIN_ROUTE = '/admin/kpi';
export const KPI_ADMIN_ROUTE_PATH = 'admin/kpi';
export const KPI_ANALYTICS_ROUTE = '/new-analytics';
export const KPI_ANALYTICS_ROUTE_PATH = 'new-analytics';
export const KPI_ANALYTICS_MENU_LABEL = 'KPI-аналитика';
export const KPI_OPERATOR_PLUS_ROLES = [
  'super_admin',
  'developer',
  'admin',
  'chief',
  'senior',
  'operator',
  'analyst',
] as const;
// Compatibility exports retained for existing imports; their scope is now operator+.
export const KPI_INTERNAL_ROLES = KPI_OPERATOR_PLUS_ROLES;
export const KPI_ADMIN_ROLES = KPI_OPERATOR_PLUS_ROLES;

export function isKpiAdminRole(role: string | null | undefined): boolean {
  const normalized = String(role || '').trim().toLowerCase();
  return (KPI_OPERATOR_PLUS_ROLES as readonly string[]).includes(normalized);
}

export const isKpiInternalRole = isKpiAdminRole;
